import {router} from './router'
import { getToken } from './utils/auth'

// 登录白名单
const whiteList = ['/login', '/codeLogin', '/mobile']
const loginPaths = ['/', '/login', '/codeLogin']

router.beforeEach((to, from, next) => {
	const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
	const token = getToken()
	if(token) {
		if(loginPaths.includes(to.path)) {
			next('/dashboard')
		} else {
			next()
		}
	} else if(whiteList.includes(to.path)) {
		next()
	} else {
		next(`/login`)
	}
})
